import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";
import { ADD_REFERRAL_SOURCE_REQUEST } from "../types";

const addReferralSource = name => async (
  dispatch,
  getState,
  { api, schema }
) => {
  const response = await api.factoring.addReferralSource(name);
  const data = normalize([response], [schema.referralSource]);
  dispatch(addEntities(data.entities));
  dispatch(
    createAction(ADD_REFERRAL_SOURCE_REQUEST)({
      items: data.result
    })
  );
  return response;
};

export default addReferralSource;
